import { TextProps, Text } from '@chakra-ui/react';
import { FC, PropsWithChildren } from 'react';

export const DatePickerHeaderText: FC<PropsWithChildren<TextProps>> = (
  props
) => <Text fontWeight="semibold" fontSize="md" pl="2" {...props} />;
